<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                v-if="this.filter.store_id != ''"
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.push('/sales')"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>

              <h2
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Sales' : 'Deleted Sales'"
              ></h2>

              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/sales/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    hide-details
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    hide-details
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="state"
                    v-model="filter.state"
                    :items="stateItems"
                    label="States"
                    hide-details
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="product"
                    v-model="filter.product_id"
                    :items="productItems"
                    label="Product"
                    hide-details
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="position"
                    v-model="filter.position_id"
                    :items="positionItems"
                    label="Customers"
                    hide-details
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="user"
                    v-model="filter.user_id"
                    :items="usersItems"
                    label="Sales Executive"
                    hide-details
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <!-- Month Year -->
                <v-col sm="3">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.month_year"
                        label="Year - Month"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.month_year = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.month"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @input="
                        getData();
                        month_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Month Year -->
                <!-- Start date -->
                <v-col sm="3">
                  <v-menu
                    v-model="start_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.start_date"
                        label="Start Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.start_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="
                        getData();
                        start_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Start date -->
                <!-- End date -->
                <v-col sm="3">
                  <v-menu
                    v-model="end_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.end_date"
                        label="End Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.end_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="
                        getData();
                        end_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /End date -->
                <!-- Store -->
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    ref="vehicle_maker"
                    v-model="filter.vehicle_maker"
                    :items="vehicle_makersItems"
                    label="Vehicle Makers"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <!-- /Store -->
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(sales.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Store</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="sales.length != 0">
              <!-- <h3 class="font-weight-bold">
                Total Product : {{ products ?? "" }}
              </h3>-->
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary mr-4"
                @click="is_excel_dialog = true"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate GST Excel</span>
              </v-btn>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default v-if="this.filter.store_id != ''">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Store Name</th>
                      <th class="text-left">Transporter Name</th>
                      <th class="text-left">Transporter Phone</th>
                      <th class="text-left">Driver Name</th>
                      <th class="text-left" style="min-width: none">
                        Driver Phone
                      </th>
                      <th class="text-left" style="min-width: none">
                        Driver KYC
                      </th>
                      <!-- <th class="text-left" style="min-width: none">Product</th>
                      <th class="text-left">Quantity</th> -->

                      <th class="text-left" style="min-width: none">
                        Vehicle Registration No
                      </th>
                      <th class="text-left" style="min-width: 180px">Date</th>
                      <th class="text-left" style="min-width: none">
                        Round of Amount
                      </th>
                      <th class="text-left" style="min-width: none">
                        Recieved Amount
                      </th>
                      <th class="text-left" style="min-width: none">
                        Balance Amount
                      </th>
                      <th class="text-left" style="min-width: none">
                        Is Recieved
                      </th>
                      <!-- <th class="text-left" style="min-width: none">Note</th> -->
                      <th class="text-left" style="min-width: none">Amount</th>
                      <th class="text-left" style="min-width: none">
                        Invoice No
                      </th>
                      <th class="text-left" style="min-width: none">
                        Gift Name
                      </th>
                      <!-- <th class="text-right" style="min-width: none">
                        Expairy Date
                      </th> -->
                      <th class="text-right action_th" style="width: 150px; min-width: 150px;">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="sales.length != 0">
                    <tr
                      v-for="(sale, i) in sales"
                      :key="`sale_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': sales.length - 1 == i,
                      }"
                    >
                      <td>
                        <input type="checkbox" v-model="sale.is_selected" />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="sale.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Sale is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="sale.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Sale is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ sale.store ? sale.store.business_name : "" }}
                      </td>
                      <td>
                        {{ sale.user ? sale.user.first_name : "" }}
                      </td>
                      <td>
                        {{ sale.user ? sale.user.phone : "" }}
                      </td>
                      <td>
                        {{ sale.driver ? sale.driver.first_name : "" }}
                      </td>
                      <td>
                        {{ sale.driver ? sale.driver.phone : "" }}
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="sale.driver && sale.driver.is_verified == 1 ? 'green' : 'red'"
                          text-color="white"
                        >
                          {{ sale.driver && sale.driver.is_verified == 1 ? 'Verified' : 'Not Verified' }}
                        </v-chip>
                      </td>
                      <td>
                        {{ sale.vehicle_registration_no || "" }}
                      </td>
                      <td>
                        {{ sale.created_at || "" }}
                      </td>
                      <td>
                        {{ sale.round_of_amount || "" }}
                      </td>
                      <td>
                        {{ sale.recieved_amount || "" }}
                      </td>
                      <td>
                        {{ sale.balance_amount || "" }}
                      </td>
                      <td>
                        {{ sale.is_recieved == 0 ? "Unpaid" : "Paid" }}
                      </td>

                      <!-- <td>
                        {{ sale.note || "" }}
                      </td> -->
                      <td>
                        {{ sale.amount || "" }}
                      </td>
                      <td>
                        {{ sale.invoice_no || "" }}
                      </td>
                      <td>
                        <template
                          v-if="
                            sale.gift_redemptions &&
                            sale.gift_redemptions.length
                          "
                        >
                          <span
                            v-for="(redemption, index) in sale.gift_redemptions"
                            :key="index"
                          >
                            {{
                              redemption.store_gift &&
                              redemption.store_gift.gift
                                ? redemption.store_gift.gift.name
                                : ""
                            }}
                          </span>
                        </template>
                      </td>

                      <!-- <td>
                        {{ sale.point_valid_till || "" }}
                      </td> -->
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip
                            v-model="is_popup"
                            bottom
                            :open-on-hover="false"
                          >
                          </v-tooltip>
                          <!-- <v-tooltip v-model="is_popup" bottom>

                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 mb-2"
                                fab
                                x-small
                                color="primary"
                                @click="is_popup = !is_popup"
                              >
                                <v-icon dark>mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View Details</span>
                          </v-tooltip>

                                onclick="is_popup = !is_popup"
                              >
                                <v-icon dark>mdi mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View Details</span>
                          </v-tooltip> -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 mb-2"
                                fab
                                x-small
                                color="primary"
                                :to="
                                  filter.product_id
                                    ? `/sales/${encryptIt(
                                        sale.id
                                      )}/sale-details?product_id=${encryptIt(
                                        filter.product_id
                                      )}`
                                    : `/sales/${encryptIt(
                                        sale.id
                                      )}/sale-details`
                                "
                              >
                                <v-icon dark>mdi-content-duplicate</v-icon>
                              </v-btn>
                            </template>
                            <span>View Sale Details</span>
                          </v-tooltip>
                          <!-- Cancel Sale Button - Only show when store_id exists and sale is active -->
                          <v-tooltip bottom v-if="filter.store_id && sale.is_active == 1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 mb-2"
                                fab
                                x-small
                                color="error"
                                @click="confirmCancelSale(sale.id)"
                              >
                                <v-icon dark>mdi-cancel</v-icon>
                              </v-btn>
                            </template>
                            <span>Cancel Sale</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(sale.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this sale</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="18" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
                <template v-slot:default v-else>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-start">Status</th>
                      <th class="text-start">Store Name</th>
                      <th class="text-start">Store State</th>
                      <th class="text-start">Store Location</th>
                      <th class="text-start">Store Code</th>
                      <th class="text-start">Total Products Qty</th>
                      <th class="text-start">Total Cash</th>
                      <th class="text-start">Total Online</th>
                      <th class="text-start">Transporter Wallet</th>
                      <th class="text-start">Driver Wallet</th>
                      <th class="text-start">Welcome Bonus</th>
                      <th class="text-start">Total Used Point</th>
                      <!-- <th class="text-left" style="min-width: none">Date</th> -->
                      <th class="text-right action_th" style="width: 150px; min-width: 150px;">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="sales.length != 0">
                    <tr
                      v-for="(sale, i) in sales"
                      :key="`sale_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': sales.length - 1 == i,
                      }"
                    >
                      <td>
                        <input type="checkbox" v-model="sale.is_selected" />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="sale.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Sale is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="sale.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Sale is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ sale.store ? sale.store.business_name : "" }}
                      </td>
                      <td>
                        {{ sale.store ? sale.store.state_jurisdiction : "" }}
                      </td>
                      <td>
                        {{ sale.store ? sale.store.store_location : "" }}
                      </td>
                      <td>
                        {{ sale.store ? sale.store.store_code : "" }}
                      </td>
                      <td>
                        {{
                          sale.total_quantity
                            ? sale.total_quantity.toFixed(2)
                            : ""
                        }}
                      </td>
                      <td>
                        {{ sale.total_cash ? sale.total_cash : 0 }}
                      </td>
                      <!-- <td>
                        {{ sale.total_online ? sale.total_online : 0 }}
                        {{ sale.total_cash ? sale.total_cash : "" }}
                      </td> -->
                      <td>
                        {{ sale.total_online ? sale.total_online : "" }}
                      </td>
                      <td>
                        {{
                          sale.total_transporter_wallet
                            ? sale.total_transporter_wallet
                            : 0
                        }}
                      </td>
                      <td>
                        {{
                          sale.total_driver_wallet
                            ? sale.total_driver_wallet
                            : 0
                        }}
                      </td>
                      <td>
                        {{
                          sale.total_welcome_bonus
                            ? sale.total_welcome_bonus
                            : 0
                        }}
                      </td>
                      <td>
                        {{
                          sale.total_used_points ? sale.total_used_points : 0
                        }}
                      </td>

                      <!-- <td>
                        {{ sale.date || "" }}
                      </td> -->
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 mb-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/sales?store_id=${encryptIt(
                                  sale.store_id
                                )}`"
                              >
                                <v-icon dark>mdi mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View Sale List</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="18" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="is_excel_dialog" width="600">
        <v-card>
          <v-card-title>Generate Sales with GST Excel</v-card-title>
          <v-divider class="mb-5"></v-divider>
          <v-card-text>
            <v-row>
              <v-col sm="12">
                <v-autocomplete
                  ref="user"
                  outlined
                  v-model="filter.gst_no"
                  :items="gstItems"
                  label="GST Number"
                  prepend-inner-icon="mdi-account"
                  clearable
                  :error-messages="errors.gst_no"
                ></v-autocomplete>
              </v-col>

              <!-- Start date -->
              <v-col sm="6">
                <v-menu
                  v-model="start_date_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="filter.start_month_year"
                      label="Year - Month"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="filter.start_month_year = null"
                      :error-messages="errors.start_month_year"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.start_month_year"
                    type="month"
                    @change="start_date_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- /Start date -->
              <!-- End date -->
              <v-col sm="6">
                <v-menu
                  v-model="end_date_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="filter.end_month_year"
                      label="Year - Month"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="filter.end_month_year = null"
                      :error-messages="errors.end_month_year"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.end_month_year"
                    type="month"
                    @change="end_date_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- /End date -->
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" @click="is_excel_dialog = false">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="generateGstExcel"
              :loading="isGstExcelLoading"
            >
              Download
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_popup" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Sales deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_popup = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_popup" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Sales deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_popup = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_store" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Sale restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_store = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      
      <!-- Sale Cancellation Confirmation Dialog -->
      <v-dialog v-model="cancel_confirmation_dialog" width="500">
        <v-card rounded="xxl">
          <v-card-title class="headline">
            <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
            Confirm Sale Cancellation
          </v-card-title>
          <v-card-text>
            <p>Are you sure you want to cancel this sale?</p>
            <p class="text--secondary">This action cannot be undone.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              color="grey" 
              text 
              @click="cancel_confirmation_dialog = false"
              :disabled="is_cancelling_sale"
            >
              No, Keep Sale
            </v-btn>
            <v-btn 
              color="error" 
              @click="cancelSale"
              :loading="is_cancelling_sale"
              :disabled="is_cancelling_sale"
            >
              Yes, Cancel Sale
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "SalesPage",
  data() {
    return {
      filter: {
        product_id: "",
        position_id: "",
        user_id: "",
        store_id: "",
        vehicle_maker: "",
        state: "",
        search_keyword: "",
        is_active: "",
        is_selected: false,
        month_year: "",
        start_date: "",
        end_date: "",
        start_month_year: "",
        end_month_year: "",
        gst_no: "",
      },
      products: 0,
      productItems: [],
      vehicle_makersItems: [],
      stateItems: [],
      usersItems: [],
      positionItems: [],
      storeItems: [],
      sales: [],
      stores: [],
      gstItems: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportSaleTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      is_restored_store: false,
      isExcelloading: false,
      isGstExcelLoading: false,
      delete_sale: false,
      is_deleted_sale: false,
      is_popup: false,
      is_select_all: false,
      isDeleteAll: false,
      month_menu: false,
      start_menu: false,
      end_menu: false,
      start_date_menu: false,
      end_date_menu: false,
      is_excel_dialog: false,
      // Sale cancellation
      cancel_confirmation_dialog: false,
      selected_sale_id: null,
      is_cancelling_sale: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
      this.getMasters();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`sales/masters`)
        .then((masters) => {
          masters = masters.data;
          //Product
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.id,
            });
          });
          //State
          masters.states.forEach((state) => {
            this.stateItems.push({
              id: state.id,
              text: state.name,
              value: state.name,
            });
          });
          //Store
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.name,
              value: store.id,
            });
            this.gstItems.push({
              id: store.id,
              text: store.gst_no,
              value: store.gst_no,
            });
          });
          //Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
          //User
          masters.users.forEach((user) => {
            this.usersItems.push({
              id: user.id,
              text: user.first_name,
              value: user.id,
            });
          });
          //User
          masters.vehicle_makers.forEach((vehicle_maker) => {
            this.vehicle_makersItems.push({
              id: vehicle_maker.id,
              text: vehicle_maker.name,
              value: vehicle_maker.name,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.vehicle_maker = this.filter.vehicle_maker
        ? this.filter.vehicle_maker
        : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      if (this.$route.query.store_id != null) {
        this.filter.store_id = this.decryptIt(this.$route.query.store_id);
      } else {
        this.filter.store_id = "";
      }
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&store_id=" +
        this.filter.store_id +
        "&position_id=" +
        this.filter.position_id +
        "&state=" +
        this.filter.state +
        "&vehicle_maker=" +
        this.filter.vehicle_maker +
        "&city=" +
        this.filter.city +
        "&month_year=" +
        this.filter.month_year +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`sales?${query}`)
        .then((response) => {
          this.sales = response.data.data;
          this.products = response.data.data1;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    async Delete_this(id) {
      this.delete_sale = true;
      await axios
        .post(`/sales/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_sale = false;
          this.is_deleted_sale = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.sales.forEach((sale) => {
        sale.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.sales.forEach((sale) => {
        if (sale.is_selected) deleteallIds.push(sale);
      });
      await axios
        .post("/sales/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/upstart_datert_date, this.form);
      this.isDeleteAll = false;
    },
    //Generate Excel
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.vehicle_maker = this.filter.vehicle_maker
        ? this.filter.vehicle_maker
        : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      if (this.$route.query.store_id != null) {
        this.filter.store_id = this.decryptIt(this.$route.query.store_id);
      } else {
        this.filter.store_id = "";
      }
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&store_id=" +
        this.filter.store_id +
        "&position_id=" +
        this.filter.position_id +
        "&state=" +
        this.filter.state +
        "&vehicle_maker=" +
        this.filter.vehicle_maker +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/sales/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    async generateGstExcel() {
      this.isGstExcelLoading = true;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.start_month_year = this.filter.start_month_year
        ? this.filter.start_month_year
        : "";
      this.filter.end_month_year = this.filter.end_month_year
        ? this.filter.end_month_year
        : "";
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&gst_no=" +
        this.filter.gst_no +
        "&start_month_year=" +
        this.filter.start_month_year +
        "&end_month_year=" +
        this.filter.end_month_year;
      await axios.get(`/sales/gst_excel_export?${query}`).then((response) => {
        this.isGstExcelLoading = false;
        this.filter.start_month_year = "";
        this.filter.end_month_year = "";
        this.filter.gst_no = "";
        window.open(`${response.data.data}`, "_blank");
      });
      this.isGstExcelLoading = false;
      this.is_excel_dialog = false;
    },
    async Restore_this(id) {
      this.restore_sale = true;
      await axios
        .post(`/sales/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_sale = false;
          this.is_restored_sale = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    
    // Sale cancellation methods
    confirmCancelSale(saleId) {
      this.selected_sale_id = saleId;
      this.cancel_confirmation_dialog = true;
    },
    
    async cancelSale() {
      this.is_cancelling_sale = true;
      try {
        const response = await axios.post('sales/cancel', {
          sale_id: this.selected_sale_id
        });
        
        if (response.data.success) {
          this.$toast.success(response.data.message || 'Sale cancelled successfully');
          this.getData(); // Refresh the table data
        } else {
          this.$toast.error(response.data.message || 'Failed to cancel sale');
        }
      } catch (error) {
        console.error('Error cancelling sale:', error);
        
        // Handle different error scenarios
        if (error.response && error.response.data && error.response.data.message) {
          this.$toast.error(error.response.data.message);
        } else if (error.response && error.response.status === 422) {
          this.$toast.error('Validation error occurred');
        } else if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error('An error occurred while cancelling the sale');
        }
      } finally {
        this.is_cancelling_sale = false;
        this.cancel_confirmation_dialog = false;
        this.selected_sale_id = null;
      }
    },
  },
};
</script>
